app.factory('welcomeService', ['$q', '$timeout', function ($q, $timeout) {
	var service = this;

	service.w1imageStyle = {
        "background-image": "url(\"/img/defaultteam.svg\")",
        "background-size": "cover"
    };

	service.teamName = undefined;
	service.teamImageURL = undefined;

	service.setInitialState = function(obj) {
		var game = obj.game;
		var gameState = obj.gameState;
		var gameConfig = obj.gameConfig;
		var rides = obj.rides;

		service.teamName = game.teamName;
		service.teamImageURL = game.teamImageURL;

		if (service.teamImageURL) {
			service.w1imageStyle = {
				"background-image": "url(\"" + service.teamImageURL + "\")",
				"background-size": "cover"
			};
		}
	}

	return service;
}]);